<div *ngIf="!criteria" class="title-container content-container">
  <svg [icon]="carouselData?.icon" class="icon svg32" [ngClass]="textColorClass" />
  <span class="overline-link mt3" [ngClass]="textColorClass"> {{ carouselData?.title ?? '' | translate }} </span>
</div>

<div *ngIf="criteria" class="content-container">
  <a class="clickable-link title-container" [ngClass]="textColorClass" (click)="setFilter()" [routerLink]="[criteriaLink]" >
    <svg [icon]="carouselData?.icon" class="icon svg32" />
    <span class="overline-link mt3"> {{ carouselData?.title ?? '' | translate }} </span>
  </a>
</div>

<div [ngClass]="{ 'carousel-container': isFloating }">
  <div *ngIf="carouselData && carouselData.data; else loading" [ngClass]="{'floating-container':isFloating}" class="carousel-wrapper">
    <div
      *ngIf="carouselData.data.length > 1"
      class="prev-page button-page"
      (selectstart)="$event.preventDefault()"
      (mousedown)="$event.preventDefault()"
      (click)="carousel.prev()"
    >
      <svg [icon]="icons.PrevPageCarousel" class="svg32"></svg>
    </div>
    <app-carousel #carousel [autoplay]="false">
      <ng-container *ngFor="let cardData of carouselData.data; let i = index">
        <ng-container *carouselItem>
          <div class="carousel-slide-content content-container">
            <app-small-card
              *ngFor="let cd of cardData"
              [data]="cd"
              [clickable]="clickable"
              [class.clickable]="clickable"
              [class.chosen]="clickable && cd.id === (chosenCatalogId$ | async)"
              (click)="choseCard(cd.id, cd.datasetId)"
              [hasShowDownloads]="hasShowDownloads"
            ></app-small-card>
          </div>
        </ng-container>
      </ng-container>
    </app-carousel>
    <div
      *ngIf="carouselData.data.length > 1"
      class="next-page button-page"
      (selectstart)="$event.preventDefault()"
      (mousedown)="$event.preventDefault()"
      (click)="carousel.next()"
    >
      <svg [icon]="icons.NextPageCarousel" class="svg32"></svg>
    </div>
  </div>
</div>
<ng-template #loading>
  <div class="loader-wrapper">
    <app-loader class="loader"></app-loader>
  </div>
</ng-template>
